export const ONBOARDING_KEYS = {
  monitoringHome: 'monitoring-home',
  monitoringAlerts: 'monitoring-alerts',
  alertDetail: 'alert-detail',
  adminAlerts: 'admin-alerts',
  adminAlertDetail: 'admin-alert-detail',
  customers: 'customers',
  customerDetail: 'customer-detail',
  sites: 'sites',
  siteAddNew: 'site-add-new',
  siteDetail: 'site-detail',
  devices: 'devices',
  addDevice: 'add-device',
  deviceEdit: 'device-edit',
  connections: 'connections',
  connectionDetail: 'connection-detail',
  users: 'users',
  addUser: 'add-user',
  userDetail: 'user-detail',
  teams: 'teams',
  addTeam: 'add-team',
  teamDetail: 'team-detail',
  alertAudit: 'alert-audit',
  cameraDetail: 'camera-detail',
  viewer: 'viewer',
} as const;

